module.exports = __webpack_public_path__ + "img/20190314.714be510.png";